export enum DOCUMENT_TABLE_POSITION_TYPE {
    DYNAMIC_PROPERTY = 'dynamic_property',
    SOURCE = 'source',
    TAG = 'tag',
    TOPIC = 'topic',
}
